import { createSlice } from "@reduxjs/toolkit";

const initialState = { loggedIn: false };

const userSlice = createSlice({
  name: "user",
  initialState: initialState,
  reducers: {
    editUser: (state, { payload }) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes

      console.log(payload);
      return { ...state, ...payload };
    },
    logOutUser: (state) => {
      return initialState;
    },
  },
});

// Action creators are generated for each case reducer function
export const { editUser, logOutUser } = userSlice.actions;

export default userSlice.reducer;
